import { withInstall } from '@element-plus/utils/with-install'

import Card from './src/card.vue'

export const ElCard = withInstall(Card)
export default ElCard

export * from './src/card'
